import { render } from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=template&id=b59939d4"
import script from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=script&lang=js"
export * from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__